/** 数値イメージと散布図の見方 */
export function TierCalculationIntuition() {
  return (
    <div className="win-rate-pick-scatter__panel">
      <h3 className="win-rate-pick-scatter__panel-title">具体例でイメージする</h3>
      <p>
        <strong>β ＝ 0</strong> のときは式の第2項がなくなるので、並び順は<strong>勝率だけ</strong>で決まります。β
        を上げると、同じ勝率でもバンピックが高いほどスコアが底上げされ、<strong>順位が入れ替わり得ます</strong>。
      </p>
      <p>
        <strong>下の散布図</strong>では、各ヒーローの勝率とバンピック率はそのままで、β を変えると<strong>等ティアスコアの帯と破線だけ</strong>が動きます。「補正を強くすると、どのあたりが同じスコア帯に見えるか」を試す用途です。
      </p>
      <p>
        色面・破線はあくまで等スコア上の目安で、実際の S〜D は手順3の人数割合で決まるため、点の位置と帯がぴたりと一致しないこともあります。
      </p>
    </div>
  );
}
